(() => {
  const root = window.Shopify?.routes?.root || '/';
  const quantityFor = (cart, id) => (cart.items || []).reduce((n, item) => n + (String(item.variant_id) === String(id) ? Number(item.quantity || 0) : 0), 0);
  const readCart = async () => {
    const response = await fetch(root + 'cart.js', { credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'} });
    if (!response.ok) throw new Error('Winkelwagen niet beschikbaar');
    const cart = await response.json();
    if (!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count)) throw new Error('Ongeldige winkelwagen');
    return cart;
  };
  const syncHeader = (cart) => {
    if (!cart || !Number.isSafeInteger(cart.item_count)) return;
    const anchor = document.getElementById('cart-icon-bubble');
    if (!anchor) return;
    let badge = anchor.querySelector('.cart-count-bubble');
    if (cart.item_count === 0) { badge?.remove(); return; }
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'cart-count-bubble';
      const number = document.createElement('span');
      number.setAttribute('aria-hidden','true');
      const accessible = document.createElement('span');
      accessible.className = 'visually-hidden';
      badge.append(number, accessible);
      anchor.appendChild(badge);
    }
    const number = badge.querySelector('[aria-hidden="true"]');
    const accessible = badge.querySelector('.visually-hidden');
    if (number) number.textContent = cart.item_count < 100 ? String(cart.item_count) : '99+';
    if (accessible) accessible.textContent = cart.item_count === 1 ? '1 product in winkelwagen' : String(cart.item_count) + ' producten in winkelwagen';
  };
  const notify = (cart) => {
    if (cart) syncHeader(cart);
    window.dispatchEvent(new CustomEvent('hk360:cart-changed', { detail: { source:'recipe' } }));
  };
  const writeState = { owner: null, reviewRequired: false };
  const acquire = (owner) => {
    if (writeState.owner !== null || writeState.reviewRequired) return false;
    writeState.owner = owner;
    window.dispatchEvent(new CustomEvent('hk360:recipe-write', { detail: { busy: true } }));
    return true;
  };
  const release = (owner) => {
    if (writeState.owner !== owner) return;
    writeState.owner = null;
    window.dispatchEvent(new CustomEvent('hk360:recipe-write', { detail: { busy: false } }));
  };
  const isBusy = () => writeState.owner !== null;
  const isBlocked = () => writeState.reviewRequired;
  const flagReview = () => {
    writeState.reviewRequired = true;
    window.dispatchEvent(new CustomEvent('hk360:recipe-write', { detail: { busy: true, reviewRequired: true } }));
  };
  window.HK360RecipeCart = { syncHeader, notify, readCart, acquire, release, isBusy, isBlocked, flagReview };
  const show = (form, ok, message) => {
    const host = form.closest('product-form');
    const success = host?.querySelector('[data-hk189-feedback]');
    const errors = host?.querySelector('.product-form__error-message-wrapper');
    const cartLink = host?.querySelector('[data-hk191-cart-link]');
    const errorText = errors?.querySelector('.product-form__error-message');
    if (success) success.hidden = true;
    if (errors) errors.hidden = true;
    if (cartLink) cartLink.hidden = true;
    if (!message) return;
    if (ok && success) {
      success.textContent = message;
      success.hidden = false;
      if (cartLink) cartLink.hidden = false;
    }
    if (!ok && errorText && errors) { errorText.textContent = message; errors.hidden = false; }
  };
  const onSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.hk-recipe-market-buy') || !form.closest('.hk-recipe-market')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.hk189Busy === 'true' || form.dataset.hk189Review === 'true') return;
    const value = String(form.querySelector('[name="id"]')?.value || '');
    const id = Number(value);
    if (!/^\d+$/.test(value) || !Number.isSafeInteger(id) || id <= 0) {
      show(form, false, 'Dit product heeft geen geldige variant. Bekijk de productpagina.');
      return;
    }
    const button = form.querySelector('button[type="submit"]');
    const buttonText = button?.querySelector('span');
    if (!button || !buttonText) return;
    if (!acquire('single')) {
      show(form, false, isBlocked()
        ? 'Een eerdere toevoeging is nog niet bevestigd. Controleer eerst je winkelwagen voordat je opnieuw iets toevoegt.'
        : 'Er wordt al een product toegevoegd. Wacht tot de winkelwagen is bijgewerkt.');
      return;
    }
    const original = buttonText.textContent;
    let review = false;
    form.dataset.hk189Busy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    buttonText.textContent = 'Toevoegen…';
    show(form, true, '');
    let before;
    try {
      try { before = await readCart(); }
      catch (_) {
        show(form, false, 'Winkelwagen niet beschikbaar. Er is niets toegevoegd. Probeer opnieuw.');
        return;
      }
      try {
        const response = await fetch(root + 'cart/add.js', {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({items:[{id,quantity:1}]})
        });
        if (!response.ok) {
          let description = '';
          try { const data = await response.json(); if (typeof data.description === 'string') description = data.description; } catch (_) {}
          show(form, false, description || 'Toevoegen is niet gelukt. Controleer de voorraad.');
          return;
        }
        let after = null;
        try { after = await readCart(); } catch (_) {}
        if (!after) {
          review = true;
          show(form, false, 'Shopify heeft gereageerd, maar wij kunnen niet controleren of het product is toegevoegd. Controleer eerst je winkelwagen.');
        } else if (quantityFor(after, id) < quantityFor(before, id) + 1) {
          review = true;
          show(form, false, 'Toevoegen niet bevestigd. Controleer eerst je winkelwagen.');
          notify(after);
        } else {
          show(form, true, '✓ Toegevoegd. Je kunt verder lezen.');
          notify(after);
        }
      } catch (_) {
        review = true;
        try {
          const after = await readCart();
          if (quantityFor(after, id) >= quantityFor(before, id) + 1) {
            review = false;
            show(form, true, '✓ Toegevoegd. Je kunt verder lezen.');
          } else show(form, false, 'Toevoegen niet bevestigd. Controleer eerst je winkelwagen.');
          notify(after);
        } catch (_) {
          show(form, false, 'Toevoegen niet bevestigd. Controleer eerst je winkelwagen.');
        }
      }
    } finally {
      form.dataset.hk189Busy = 'false';
      form.dataset.hk189Review = review ? 'true' : 'false';
      button.disabled = review;
      button.removeAttribute('aria-busy');
      buttonText.textContent = review ? 'Controleer winkelwagen' : original;
      if (review) flagReview();
      release('single');
    }
  };
  document.addEventListener('submit', onSubmit, true);
  const initializeSticky = () => {
    const panel = document.getElementById('hk-recipe-ingredients');
    const wrapper = panel?.closest('.shopify-section');
    if (!panel || !wrapper) return;
    const update = () => {
      const viewport = window.visualViewport?.height || window.innerHeight;
      wrapper.classList.toggle('hk189-can-stick', window.innerWidth > 900 && panel.getBoundingClientRect().height + 44 < viewport);
    };
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(update).observe(panel);
    window.addEventListener('resize', update, { passive:true });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeSticky);
  else initializeSticky();
})();